import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import { Icon, DatePicker, TimeInput } from '../../..';
import moment from 'moment';
import { utils, translations } from 'gipsy-misc';

import Field from '../../components/Field';

var CompletionTime = function (_PureComponent) {
  _inherits(CompletionTime, _PureComponent);

  function CompletionTime() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CompletionTime);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CompletionTime.__proto__ || Object.getPrototypeOf(CompletionTime)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (data) {
      _this.props.onChange(data);
    }, _this.onTimeInputChange = function (_ref2) {
      var paramName = _ref2.paramName,
          value = _ref2.value;

      var completionTimeValue = _this.props.value;
      var newValue = utils.datetime.createDateTimeStrFromDigitsAndPeriod(utils.datetime.format(completionTimeValue), value.hour, value.minute);
      _this.props.onChange({
        paramName: paramName,
        value: newValue
      });
    }, _this.onDatePickerChange = function (_ref3) {
      var paramName = _ref3.paramName,
          value = _ref3.value;

      var completionTimeValue = _this.props.value;
      var newValue = utils.datetime.createDateTimeStrFromDigitsAndPeriod(value, moment(completionTimeValue).hour(), moment(completionTimeValue).minute());
      _this.props.onChange({
        paramName: paramName,
        value: newValue
      });
    }, _this.deactivateField = function (e) {
      var id = _this.props.id;

      _this.props.deactivateField && _this.props.deactivateField(e, id);
      _this.props.onChange({ paramName: id, value: '' });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CompletionTime, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          mode = _props.mode,
          className = _props.className,
          label = _props.label,
          icon = _props.icon,
          id = _props.id,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          toggleField = _props.toggleField,
          value = _props.value,
          completed = _props.completed,
          noPadding = _props.noPadding,
          backgroundHover = _props.backgroundHover;


      var hour = moment(value).hour();
      var minute = moment(value).minute();
      var displayValue = utils.datetime.isValid(value) ? utils.datetime.humanizeDateTime(value, value) : 'Backlog';

      return React.createElement(
        Fragment,
        null,
        completed === 1 && React.createElement(
          Field,
          {
            onClick: utils.DOM.stopPropagation,
            backgroundHover: backgroundHover,
            noPadding: noPadding,
            className: 'date-field' + (className ? ' ' + className : '') + (isActive ? ' active' : '') + (isOpen ? ' open' : '') },
          React.createElement(
            'div',
            { className: 'row click-field gp-layout gp-row gp-space-between', onClick: function onClick(e) {
                return toggleField(e, id);
              } },
            React.createElement(
              'div',
              { className: 'field-label' },
              React.createElement(Icon, { className: 'label-icon', icon: icon }),
              React.createElement(
                'span',
                { className: 'label-text' },
                label
              )
            ),
            displayValue && React.createElement(
              'div',
              { className: 'value' },
              displayValue
            )
          ),
          mode !== 'preview' && React.createElement(
            'div',
            { className: 'row open-row' },
            React.createElement(
              AnimateHeight,
              { duration: 300, height: isOpen ? 'auto' : 0 },
              React.createElement(DatePicker, {
                className: 'active',
                paramName: id,
                selectedDay: value,
                onChange: this.onDatePickerChange,
                pastDatesOnly: true
              }),
              React.createElement(
                'div',
                { className: 'gp-layout gp-row gp-space-between', style: { marginBottom: '20px' } },
                React.createElement(
                  'div',
                  { className: 'field-label' },
                  React.createElement(Icon, { icon: 'Clock', className: 'label-icon' }),
                  React.createElement(
                    'span',
                    { className: 'label-text' },
                    translations.taskPanel.completionTime.time
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'value' },
                  React.createElement(TimeInput, {
                    showPeriod: true,
                    format: '12h',
                    paramName: id,
                    hour: hour,
                    minute: minute,
                    onChange: this.onTimeInputChange
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CompletionTime;
}(PureComponent);

CompletionTime.propTypes = {
  mode: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.array,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  deactivateField: PropTypes.func,
  toggleField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  pinTime: PropTypes.string,
  noPadding: PropTypes.bool,
  backgroundHover: PropTypes.string,
  showClose: PropTypes.bool
};
CompletionTime.defaultProps = {
  showClose: true
};


export default CompletionTime;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/CompletionTime/index.js
// module id = 1132
// module chunks = 0